/**
 * Resolves the deploy environment used to tag PostHog events and Sentry errors.
 *
 * `import.meta.env.PROD` is `true` for ANY production build — including Vercel
 * **Preview** (dev) deploys, which also run `vite build`. Relying on it caused
 * preview/dev events to be tagged `environment: "production"` and pollute the
 * production PostHog dashboards.
 *
 * `VITE_APP_ENV` is set explicitly per-environment in the Vercel project
 * settings: Production = "production", Preview = "development". When it is not
 * set we resolve to "development" — never silently "production" — so a
 * misconfigured build fails safe rather than poisoning production metrics.
 */

export type AppEnvironment = "production" | "development";

export function getEnvironment(): AppEnvironment {
  const appEnv = (import.meta.env.VITE_APP_ENV as string | undefined)
    ?.trim()
    .toLowerCase();
  if (appEnv === "production" || appEnv === "development") return appEnv;
  return "development";
}
